module.exports = __webpack_public_path__ + "img/recognition-header-bubble-3.776915d1.png";